import React from 'react';
import './header.scss';

const Header = () => {
  return (
    <header className="sm-header--container" data-testid="Header__Container">
      <div>(Survey Header Goes Here)</div>
    </header>
  );
};

export default Header;
